export default __webpack_public_path__ + "static/media/Gargantuan Fist.45a3c1e0.jpg";